import getField from '../getField'

const isOnboardingComplete = user => !!getField(user, 'userProfile.onboardingComplete')

export default isOnboardingComplete



// WEBPACK FOOTER //
// ./src/utilities/Data/User/isOnboardingComplete.js